<template>
<div class="animated fadeIn">
  <v-client-table :data="rooms" :columns="columns" :options="options" :theme="theme">
    <template slot="actions" slot-scope="data">
      <b-button class="mr-1" size="sm" variant="primary" @click="selectRoom(data.row)">Select</b-button>
    </template>
  </v-client-table>
</div>
</template>

<script>
import Vue from 'vue'
import {
  mapState,
} from 'vuex'


export default {
  name: "RoomSearch",
  props: {
    rooms: Array
  },
  data() {
    return {
      columns: [
        'room_number',
        'price',
        'number_of_beds',
        'max_occupiers',
        'toilet_type',
        'has_ac',
        'actions'
      ],
      options: {
        headings: {
          room_number: 'Room Number',
          price: 'Bhent',
          number_of_beds: "Beds",
          max_occupiers: "Max Occupiers",
          toilet_type: "Toilet",
          has_ac: "AC",
          actions: 'Actions'
        },
        sortable: [],
        filterable: [],
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        pagination: {
          chunk: 5,
          edge: true,
          nav: 'scroll'
        },
        perPage: 25,
      },
      theme: 'bootstrap4',
    }
  },
  methods: {
    selectRoom(room) {
      this.$emit('selected', room)
    }
  }
}
</script>
